import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AreasSeatService } from 'src/app/services/areas-seat.service';
import { InfoCardComponent } from '../../shared/info-card/info-card.component';
import { GenerateMapService } from 'src/app/services/generate-map.service';
import { BlockedSeatsService } from 'src/app/services/blocked-seats.service';

@Component({
  selector: 'app-hidden-seats',
  templateUrl: './hidden-seats.component.html',
  styleUrls: ['./hidden-seats.component.scss']
})
export class HiddenSeatsComponent implements OnInit, OnChanges {

  @Input() hiddenTypes: any[] = [];
  @Input() admin: boolean = false;
  @Output() deleteType = new EventEmitter<any>();
  defaultColors: any[] = [];

  @Input() canvas!: any;
  @Input() assignedHidden: any[] = [];
  @Input() selectedSeats: any[] = [];
  @Input() capacity: number = 0;
  @Input() fromCreate!: boolean;
  @Input() fromEvent!: boolean;
  @Output() changeAssigned = new EventEmitter<any>();
  @Output() typeAssigned = new EventEmitter<any>();

  hiddenEdit!: any;
  hiddenSeats!: any;
  enabledClickBtns: boolean = true;

  showNewForm: boolean = false;
  newHiddenName: string = '';
  newHiddenColor: string = '';
  newHiddenCode: string = '';

  get countHiddenSeats(): number {
    if (!this.canvas) return 0;
    let count = 0;
    this.canvas._objects?.forEach((obj: any) => {
      if (obj.groupSeat) {
        obj._objects?.[1]?._objects?.forEach((seat: any) => {
          if (seat.eventSeat && seat.isVisible === false) {
            count++;
          }
        });
      }
    });
    return count;
  }

  @Input() idEvent!: number;
  @Input() idSpace!: number;
  @Input() selectedSession!: number;
  oldHiddenEdit!: any;
  oldHiddenTypes!: any[];

  constructor(private areasSeatService: AreasSeatService, private dialog: MatDialog, private generateMapService: GenerateMapService,
    private blockedSeatsService: BlockedSeatsService
  ) { }

  ngOnInit(): void {
    this.defaultColors = this.areasSeatService.getDefaultColorsHidden();
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  typeAssignActive(type: any, index: number) {
    this.hiddenSeats = index;
    this.hiddenEdit = null;
    this.enabledClickBtns = false;
    this.oldHiddenEdit = { ...type };
    this.oldHiddenTypes = JSON.parse(JSON.stringify(this.hiddenTypes));
    this.typeAssigned.emit(type);
  }

  assignSeats(event: boolean) {
    if (event) {
      this.hiddenEdit = null;
      if (this.idEvent) {
        // Guardar los cambios realizados
        this.editHiddenTypes();
      } else {
        this.editHiddenSpace();
      }
    } else {
      if (this.oldHiddenEdit) {
        this.hiddenTypes[this.hiddenSeats] = this.oldHiddenEdit;
      }
      if (this.oldHiddenTypes) {
        this.hiddenTypes = this.oldHiddenTypes;
      }
      this.enabledClickBtns = true;
      this.hiddenSeats = null;
      this.hiddenEdit = null;
      this.changeAssigned.emit(this.hiddenTypes);
    }
  }

  closeEdit() {
    this.hiddenEdit = null;
    this.hiddenSeats = null;
  }

  editItem(index: number, type: any) {
    if (this.hiddenEdit === index) {
      this.cancelEditForm();
      return;
    }
    this.oldHiddenEdit = { ...type };
    this.hiddenEdit = index;
  }

  cancelEditForm() {
    if (this.oldHiddenEdit != null && this.hiddenEdit != null) {
      this.hiddenTypes[this.hiddenEdit] = { ...this.oldHiddenEdit };
    }
    this.hiddenEdit = null;
    this.oldHiddenEdit = null;
  }

  saveEditForm() {
    this.assignSeats(true);
  }

  generateCode(): void {
    this.newHiddenCode = Math.random().toString(16).slice(2, 8).toUpperCase();
  }

  openNewForm() {
    const idHidden = this.hiddenTypes ? this.hiddenTypes.length : 0;
    this.newHiddenColor = this.areasSeatService.getIndexColorHidden(idHidden);
    this.newHiddenName = '';
    this.generateCode();
    this.showNewForm = true;
  }

  cancelNewForm() {
    this.showNewForm = false;
    this.newHiddenName = '';
    this.newHiddenColor = '';
    this.newHiddenCode = '';
  }

  confirmNewHidden() {
    const name = this.newHiddenName.trim();
    if (!name) {
      this.openDialogInfo('Por favor, introduce un nombre para el bloqueo.');
      return;
    }
    if (!this.newHiddenCode.trim()) {
      this.generateCode();
    }
    const code = this.newHiddenCode.trim().toUpperCase();
    const objLevel = { name: name, color: this.newHiddenColor || '#cccccc', id_seats: [], code: code };
    this.showNewForm = false;
    this.newHiddenName = '';
    this.newHiddenColor = '';
    this.newHiddenCode = '';
    this.hiddenTypes.push(objLevel);
    const newIndex = this.hiddenTypes.length - 1;
    this.generateMapService.setBlockedSeats(this.hiddenTypes);
    this.typeAssignActive(objLevel, newIndex);
  }

  // Función para agregar un nuevo tipo de asiento oculto (kept for compatibility)
  addHiddenType() {
    this.openNewForm();
  }

  editHiddenTypes() {
    this.hiddenTypes = this.hiddenTypes.map(value => {
      let uniqueSeats = value.id_seats ? Array.from(new Set(value.id_seats)) : [];
      value.id_seats = uniqueSeats;
      return value;
    });
    // Crear el tipo de asiento oculto en el evento
    this.blockedSeatsService.createBlockedSeatsBySession(this.idEvent, this.selectedSession, {
      blocked_seats: this.hiddenTypes.map(value => ({
        name: value.name,
        color: value.color,
        code: value.code,
        id_event: +this.idEvent,
        id_space: +this.idSpace,
        id_seats: value.id_seats?.length > 0 ? value.id_seats : null
      }))
    }).subscribe({
      next: (res: any) => {
        // Sync local hiddenTypes with DB ids so subsequent deletes call the API
        if (res?.data && Array.isArray(res.data)) {
          this.hiddenTypes = this.hiddenTypes.map((ht, i) => ({
            ...ht,
            id: res.data[i]?.id ?? ht.id
          }));
        }
        this.enabledClickBtns = true;
        this.hiddenSeats = null;
        this.hiddenEdit = null;
        this.changeAssigned.emit(this.hiddenTypes);
        this.openDialogInfo('Cambios guardados correctamente.');
      }, error: (err: any) => {
        this.openDialogInfo('Ha ocurrido un error al guardar los cambios. Por favor, inténtalo de nuevo más tarde.');
      }
    });
  }

  editHiddenSpace() {
    // Limpiar los id_seats y hacer que sean únicos los ids que tenga dentro
    this.hiddenTypes = this.hiddenTypes.map(value => {
      let uniqueSeats = value.id_seats ? Array.from(new Set(value.id_seats)) : [];
      value.id_seats = uniqueSeats;
      return value;
    });
    // Crear el tipo de asiento oculto en el evento
    this.blockedSeatsService.createBlockedSeatsBySpace(this.idSpace, {
      blocked_seats: this.hiddenTypes.map(value => ({
        name: value.name,
        color: value.color,
        code: value.code,
        id_event: null,
        id_space: +this.idSpace,
        id_seats: value.id_seats?.length > 0 ? value.id_seats : null
      }))
    }).subscribe({
      next: (res: any) => {
        if (res?.data && Array.isArray(res.data)) {
          this.hiddenTypes = this.hiddenTypes.map((ht, i) => ({
            ...ht,
            id: res.data[i]?.id ?? ht.id
          }));
        }
        this.enabledClickBtns = true;
        this.hiddenSeats = null;
        this.hiddenEdit = null;
        this.changeAssigned.emit(this.hiddenTypes);
        this.openDialogInfo('Cambios guardados correctamente.');
      }, error: (err: any) => {
        this.openDialogInfo('Ha ocurrido un error al guardar los cambios. Por favor, inténtalo de nuevo más tarde.');
      }
    });
  }

  deleteItem(index: any) {
    const hidden = this.hiddenTypes[index];
    const hasSeats = hidden.id_seats && hidden.id_seats.length > 0;

    if (hasSeats) {
      const dialogRef = this.dialog.open(InfoCardComponent, {
        panelClass: 'info-dialog',
        data: {
          icon: true,
          warning: true,
          text: `El grupo <strong>${hidden.name}</strong> tiene ${hidden.id_seats.length} asiento/s asignado/s. ¿Seguro que quieres eliminarlo? Los asientos quedarán libres.`,
          btnCancel: true
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.performDelete(hidden, index);
        }
      });
    } else {
      this.performDelete(hidden, index);
    }
  }

  private performDelete(hidden: any, index: number) {
    if (hidden.id) {
      this.deleteHiddenEvent(hidden.id, index);
    } else {
      this.hiddenTypes.splice(index, 1);
      this.changeAssigned.emit(this.hiddenTypes);
    }
  }

  deleteHiddenEvent(blockedId: any, index: number = null) {
    this.blockedSeatsService.deleteBlocked(blockedId).subscribe({
      next: (res: any) => {
        if (index != null) {
          this.hiddenTypes.splice(index, 1);
          this.changeAssigned.emit(this.hiddenTypes);
        }
        this.openDialogInfo('El tipo de asiento oculto del evento se ha eliminado correctamente.');
      }, error: (err: any) => {
        this.openDialogInfo('Ha ocurrido un error al eliminar el tipo de asiento oculto del evento. Por favor, inténtalo de nuevo más tarde.');
      }
    });
  }

  openDialogInfo(text: string) {
    this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      data: {
        icon: true,
        text: text,
        btnCancel: false
      }
    });
  }

}
